/* Bocock Collegiate mega menu decorator.

   Reads the JSON map that snippets/bocock-mega.liquid renders (school url,
   title, team colors, logo, product count) and decorates every matching nav
   link, in the desktop mega panel and in the mobile drawer, as a team color
   tile. Also flattens the alphabetical school groups into one grid, converts
   the Shop All group into the dark rail, appends live product counts, and
   badges champions and coming soon programs.

   Fails silently and completely: without this script or its data, Prestige's
   stock mega menu renders untouched. */

(function () {
  var CHAMPS = ['michigan-wolverines', 'indiana-hoosiers', 'oklahoma-sooners'];

  function decorate() {
    var el = document.getElementById('bk-mega-data');
    if (!el) return;
    var data;
    try {
      data = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (!data || !data.schools) return;

    data.schools.forEach(function (s) {
      var links = document.querySelectorAll('a[href$="' + s.u + '"]');
      links.forEach(function (a) {
        if (a.dataset.bkMega) return;
        if (!a.closest('.mega-menu') && !a.closest('#sidebar-menu') && !a.closest('.header__dropdown-menu')) return;
        a.dataset.bkMega = '1';
        a.classList.add('bk-school');
        a.style.setProperty('--bk-bg', s.bg || '#141414');
        a.style.setProperty('--bk-tx', s.tx || '#ffffff');

        if (s.logo) {
          var img = document.createElement('img');
          img.src = s.logo;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 34;
          img.height = 34;
          img.onerror = function () { img.remove(); };
          a.prepend(img);
        }

        var isChamp = CHAMPS.some(function (c) { return s.u.indexOf(c) > -1; });
        if (s.n === 0) {
          a.dataset.soon = '1';
          addChip(a, 'Coming Soon', false);
        } else if (isChamp) {
          addChip(a, 'Champions', true);
        }

        var groupUl = a.closest('ul');
        var groupLi = groupUl ? groupUl.closest('li') : null;
        if (groupLi && groupLi.parentElement && groupLi.parentElement.classList.contains('mega-menu__linklist')) {
          groupLi.classList.add('bk-flat');
        }
      });
    });

    document.querySelectorAll('.mega-menu__linklist > li').forEach(function (li) {
      var head = li.querySelector(':scope > a');
      if (head && /shop all/i.test(head.textContent)) li.classList.add('bk-rail');
    });

    if (data.counts) {
      Object.keys(data.counts).forEach(function (u) {
        document.querySelectorAll('.bk-rail a[href$="' + u + '"]').forEach(function (a) {
          if (a.querySelector('.bk-count')) return;
          if ((a.getAttribute('href') || '').indexOf('/discount/') === 0) return;
          var c = document.createElement('span');
          c.className = 'bk-count';
          c.textContent = data.counts[u];
          a.appendChild(c);
        });
      });
    }

    document.querySelectorAll('a[href^="/discount/GAMEDAYSET"]').forEach(function (a) {
      a.classList.add('bk-gameday');
    });

    document.querySelectorAll('.mega-menu').forEach(function (m) {
      if (!m.querySelector('.bk-school')) return;
      m.classList.add('bk-mega-on');
      if (!m.querySelector('.bk-mega-head')) {
        var h = document.createElement('div');
        h.className = 'bk-mega-head';
        var st = document.createElement('strong');
        st.textContent = 'Shop by School';
        var sp = document.createElement('span');
        sp.textContent = '21 programs. Officially licensed. Boxes painted by hand in Danli, Honduras.';
        h.appendChild(st);
        h.appendChild(sp);
        m.prepend(h);
      }
    });
  }

  function addChip(a, label, champ) {
    var chip = document.createElement('span');
    chip.className = champ ? 'bk-chip bk-chip--champ' : 'bk-chip';
    chip.textContent = label;
    a.appendChild(chip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }
})();
